
import ErrorCode from '@/constants/ErrorCode';
import Application from '@/models/applications/application';
import ApplicationService from '@/services/applicationService';
import { ElMessage } from 'element-plus';
import { Options, Vue } from 'vue-class-component';

export default class ApplicationManage extends Vue {
  private defaultPath = '';

  private applicationPath = '';

  private imuserPath = '';

  private appConfigPath = '';

  private application: Application = {};

  public appId = '';

  mounted(): void {
    this.appId = this.$route.params.appId as string;
    this.defaultPath = this.$route.name as string;
    console.info(this.defaultPath);
    this.applicationPath = `/application/${this.appId}/applicationDetail`;
    this.imuserPath = `/application/${this.appId}/imuser`;
    this.appConfigPath = `/application/${this.appId}/appConfiguration`;
    this.loadData();
  }

  loadData(): void {
    ApplicationService.get(this.appId)
      .then((result) => {
        if (result.code === ErrorCode.Success) {
          this.application = result.data;
        } else {
          ElMessage.error(result.msg);
        }
      })
      .catch((response) => {
        ElMessage.error(response);
      });
  }
}
